export const validateAnalyticModelNameForCreate = async (siteId, name) => {
  let result = null;
  let model = {
    siteId: siteId,
    name: name,
  };
  try {
    result = await window.axios.post(
      '/v1/AnalyticModel/create/validatename/',
      model
    );
    return result.data.data;
  } catch (err) {
    console.error(err);
    return Promise.reject(err);
  }
};

export const validateAnalyticModelNameForUpdate = async (siteId, id, name) => {
  let result = null;
  let model = {
    id: id,
    name: name,
    siteId: siteId,
  };
  try {
    result = await window.axios.post(
      '/v1/AnalyticModel/update/validatename/',
      model
    );
    return result.data.data;
  } catch (err) {
    console.error(err);
    return Promise.reject(err);
  }
};

export const validateAnalyticModelDataForRange = async (
  modelId,
  startTime,
  endTime
) => {
  try {
    const result = await window.axios.get(
      `/v1/analyticmodel/energy/weathernormalized/validate/?modelid=${modelId}&starttime=${startTime}&endtime=${endTime}`
    );
    return result.data.data;
  } catch (err) {
    console.error(err);
    return Promise.reject(err);
  }
};

export const createAnalyticModel = async (siteId, model) => {
  let result = null;
  try {
    result = await window.axios.post(
      '/v1/AnalyticModel/sites/' + siteId,
      model
    );
    return result.data.data;
  } catch (err) {
    return Promise.reject(err);
  }
};

export const updateAnalyticModel = async (siteId, model) => {
  let result = null;
  try {
    result = await window.axios.put('/v1/AnalyticModel/sites/' + siteId, model);
    return result.data.data;
  } catch (err) {
    return Promise.reject(err);
  }
};

export const getAnalyticModel = async (modelId) => {
  let result = null;
  try {
    result = await window.axios.get('/v1/AnalyticModel/' + modelId);
    let model = result.data.data;
    return model;
  } catch (err) {
    console.error(err);
    return Promise.reject(err);
  }
};

//Analytics Service start
// TODO: keep, will rewrite
export const downLoadAnalyticModelZip = async (siteId, analyticModel) => {
  let result = null;
  const requestOptions = {
    headers: {
      'X-API-Type': 'analytics',
    },
    responseType: 'blob',
    // The download endpoint binds a different, smaller resource model than
    // the one GET /v1/AnalyticModel/{id} returns (Core's
    // AnalyticModelResourceModel: Id, ModelName, StartDateTime, EndDateTime,
    // NonRoutineEvents). Posting the full model back verbatim left ModelName
    // empty and the API answered 400 "The ModelName field is required."
    //
    // NonRoutineEvents is sent empty on purpose: the action only reads Id and
    // the two dates, while every item it does receive is validated against
    // the full NRE resource model (type name, comment, dates). The model's
    // own NRE entries carry just { id, name, selected }, so forwarding them
    // made the API answer 400 "The Comment field is required." for any model
    // that has an NRE attached.
    data: {
      id: analyticModel.id,
      modelName: analyticModel.name,
      startDateTime: analyticModel.startDateTime,
      endDateTime: analyticModel.endDateTime,
      nonRoutineEvents: [],
    },
    method: 'post',
    url:
      '/v1/analytics/energy/sites/' +
      siteId +
      '/weathernormalized/predictions/download',
  };

  try {
    result = await window.axios.request(requestOptions);
    let zip = result.data;
    return zip;
  } catch (err) {
    console.log(err);
    return Promise.reject(err);
  }
};
//Analytics Service end

export const getEndUses = async (siteId) => {
  try {
    let result = await window.axios.get('/v1/AnalyticModel/EndUse/' + siteId);
    let endUses = result.data.data;
    return endUses;
  } catch (err) {
    console.error(err);
    return Promise.reject(err);
  }
};

export const getAnalysisTypes = async () => {
  try {
    let result = await window.axios.get('/v1/AnalyticModel/AnalysisType/');
    let types = result.data.data;
    return types;
  } catch (err) {
    console.error(err);
    return Promise.reject(err);
  }
};

export const getAnalyticFactors = async () => {
  try {
    let result = await window.axios.get('/v1/AnalyticModel/AnalyticFactor/');
    let factors = result.data.data;
    return factors;
  } catch (err) {
    console.error(err);
    return Promise.reject(err);
  }
};

export const getNREs = async (siteId) => {
  let result = null;
  try {
    result = await window.axios.get(
      '/v1/AnalyticModel/NonRoutineEvent/' + siteId
    );
    let nres = result.data.data;
    return nres;
  } catch (err) {
    console.error(err);
    return Promise.reject(err);
  }
};

export default {
  getAnalyticModel,
  createAnalyticModel,
  updateAnalyticModel,
  validateAnalyticModelNameForCreate,
  validateAnalyticModelNameForUpdate,
  validateAnalyticModelDataForRange,
  downLoadAnalyticModelZip,

  getEndUses,
  getAnalysisTypes,
  getAnalyticFactors,
  getNREs,
};
